import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface statusPopupState {
  open: boolean;
  status: string | null;
  message: string | null;
  locationPath?: string | null;
  isFunction?: boolean;
  locationFunction?: any;
  buttonStatus: boolean;
  btnStatus?: string;
  refreshValue: any;
  anotherDeviceAuth: boolean;
  title?: string;
  buttonConfirm?: boolean; // Added to handle button confirmation
  btnFunc?: any; // Function to be called on button click
  isCross?: boolean,
  submessage?: string | null;
}

const initialState: statusPopupState = {
  open: false,
  status: null,
  message: null,
  locationPath: null,
  buttonStatus: false,
  refreshValue: 0,
  anotherDeviceAuth: false,
  locationFunction: null,
  isFunction: false,
  title: "",
  buttonConfirm: false, // Added to handle button confirmation
  btnFunc: null, 
  isCross: false,
  submessage: null,
};

const statusPopupSlice = createSlice({
  name: "statusPopup",
  initialState,
  reducers: {
    setStatusPopup(state, action) {
      state.title = action.payload.title;
      state.open = true;
      state.status = action.payload.status;
      state.message = action.payload.message;
      state.buttonStatus = action.payload.buttonStatus;
      state.buttonConfirm = action.payload.buttonConfirm;
      if (action.payload.btnFunc)
        state.btnFunc = action.payload.btnFunc;
      state.locationFunction = action.payload.locationFunction;
      state.isFunction = action.payload.isFunction;
      if (action.payload.anotherDeviceAuth) {
        state.anotherDeviceAuth = action.payload.anotherDeviceAuth;
      }
      if (action.payload.locationPath)
        state.locationPath = action.payload.locationPath;
      state.isCross = action.payload.isCross
      state.submessage = action.payload.submessage
    },

    clearStatusPopup(state) {
      state.open = false;
      state.locationPath = null;
      state.anotherDeviceAuth = false;
      state.locationFunction = null;
      state.isFunction = false;
      state.title = "";
      state.buttonConfirm = false; // Reset button confirmation state
      state.btnFunc = null; // Reset button function
      state.isCross = false;
      state.submessage = null;
    },
    refreshStatusPopup(state, action) {
      state.refreshValue = action.payload;
    },
  },
});

export const { setStatusPopup, clearStatusPopup, refreshStatusPopup } =
  statusPopupSlice.actions;
export const statusPopupSelector = (state: RootState) => state?.statusPopup;
export default statusPopupSlice.reducer;
